import {
  IDeleteJobParams,
  IDeleteJobResponse,
  IJobVisibilityParams,
  IJobVisibilityResponse,
  IListQueuesResponse,
  IResponseBase,
  IUpdateJobParams,
  IUpdateJobResponse,
} from "@zeal/common";

import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import {
  bulkJobStatus,
  createJob,
  deleteJob,
  jobStatus,
  listQueues,
  updateJob,
  updateJobVisibility,
} from "./routes";

export interface IQuinnClient {
  deleteJob(body: IDeleteJobParams): Promise<IDeleteJobResponse>;
  updateJob(body: IUpdateJobParams): Promise<IUpdateJobResponse>;
  updateJobVisibility(
    body: IJobVisibilityParams
  ): Promise<Omit<IResponseBase<IJobVisibilityResponse>, "data">>;
  listQueues(): Promise<IListQueuesResponse[]>;
}

export class QuinnClient extends AbstractApiClient implements IQuinnClient {
  public readonly BulkJobStatus = bulkJobStatus(this.Instance);
  public readonly createJob = createJob(this.Instance);
  public readonly deleteJob = deleteJob(this.Instance);
  public readonly jobStatus = jobStatus(this.Instance);
  public readonly listQueues = listQueues(this.Instance);
  public readonly updateJob = updateJob(this.Instance);
  public readonly updateJobVisibility = updateJobVisibility(this.Instance);
}
